class UsersController {
	constructor(AuthFactory, RolesFactory, UsersFactory, $rootScope, ngDialog, $filter) {
		"ngInject";
		const vm = this;

		let $translate = $filter('translate');

		vm.rootScope = $rootScope;

		vm.$onInit = () =>{
			vm.showUserForm = false;
			vm.roles = [];
			RolesFactory.getAll().then(response =>{
				vm.roles = response.data;
			});
			reloadData();
		};

		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'username',
					enableFiltering: true,
					name: $translate('USERNAME'),
				}, {
					field: 'email',
					enableFiltering: true,
					name: $translate('EMAIL'),
				}, {
					field: 'role.display_name',
					enableFiltering: true,
					name: $translate('ROLE'),
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
					'<div ' +
					'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
					'<div class="buttons">' +
					'<button class="btn btn-sm accent" translate ' +
					'data-toggle="modal" ' +
					'data-target="#changePasswordModal" ' +
					'ng-click="grid.appScope.vm.changePasswordForm(row.entity)">CHANGE_PASSWORD</button> ' +
					'<button class="btn btn-sm btn-warning" translate ' +
					'ng-click="grid.appScope.vm.openForm(row.entity)">EDIT</button> ' +
					'</div>' +
					'</div>',
					width: '320',
				},
			],
		};

		vm.submit = () =>{
			vm.user.permissions = vm.userPermissions;
			if(vm.user.id){
				UsersFactory.update(vm.user.id, vm.user).then(response => {
					ngDialog.open({template: 'successTemplate'});
					reloadData();
					vm.user = response.data;
				});
			}else{
				UsersFactory.create(vm.user).then(response => {
					ngDialog.open({template: 'successTemplate'});
					reloadData();
					vm.user = response.data;
				});
			}
		};

		vm.changePasswordForm = (user) =>{
			vm.user = angular.copy(user, vm.user);
			vm.password = {};
		};

		vm.changePassword = () =>{
			vm.password.id = vm.user.id;
			AuthFactory.changePassword(AuthFactory.USER_TYPES.USER, vm.password).then(response =>{
				ngDialog.open({template:'successTemplate'});
			});
		};

		vm.openForm = (user) =>{
			vm.user = {};
			vm.userPermissions = [];
			if(user){
				angular.copy(user, vm.user);
			}
			vm.showUserForm = true;
		};

		vm.closeForm = () =>{
			vm.showUserForm = false;
		};

		function reloadData(){
			UsersFactory.getAll().then(response => {
				vm.gridOptions.data = response.data;
			});
		}
	}
}

export default UsersController;



// WEBPACK FOOTER //
// ./client/app/components/users/users.controller.js